// SPDX-License-Identifier: MIT
//
// Shared OS detection + per-OS install commands. Extracted from
// forgejo-next-steps.ts so the "Connecter mon Claude" panel (connect-claude.ts)
// and the bootstrap next-steps panel share one source of truth for "which Node
// install command for this OS". Pure logic only — no DOM, no i18n, no CSS — so
// each consumer renders its own copy/markup. osFromStrings is split out so the
// detection logic is testable without stubbing navigator.

export type OS = 'windows' | 'mac' | 'linux';

// iOS / Android bucket as mac / linux respectively (shared brew/curl heritage).
export function osFromStrings(platform: string, ua: string): OS {
  const p = platform.toLowerCase();
  const u = ua.toLowerCase();
  if (p.includes('win') || u.includes('windows')) return 'windows';
  if (p.includes('mac') || u.includes('mac os') || u.includes('iphone') || u.includes('ipad')) return 'mac';
  return 'linux';
}

export function detectOS(): OS {
  const uad = (navigator as { userAgentData?: { platform?: string } }).userAgentData;
  return osFromStrings(uad?.platform ?? navigator.platform ?? '', navigator.userAgent ?? '');
}

export function nodeInstallCommand(os: OS): string {
  return os === 'windows'
    ? 'winget install OpenJS.NodeJS.LTS'
    : os === 'mac'
    ? 'brew install node'
    : 'sudo apt-get install -y nodejs npm';
}

export const CLAUDE_CODE_INSTALL_CMD = 'npm install -g @anthropic-ai/claude-code';

export function osLabel(os: OS): string {
  return os === 'windows' ? 'Windows' : os === 'mac' ? 'macOS' : 'Linux';
}
